export default "__VITE_ASSET__B_oM0g3e__"